import { useRef, useEffect } from 'react';

// mimc didUpdate, i.e: same as useEffect, but not get called on mount
export default function useDidUpdate(callback, deps) {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      callback();
    } else {
      didMountRef.current = true;
    }
  }, deps);
}
